import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AuthenticationTicket, PollResponse } from '../model';

@Injectable()
export class SithsEIDService {
  private httpClient = inject(HttpClient);

  private url: string;
  private authTicket: AuthenticationTicket;

  public setUrl(url: string): void {
    this.url = url;
  }

  public setTicket(ticket: AuthenticationTicket): void {
    this.authTicket = ticket;
  }

  public getTicket(): AuthenticationTicket {
    return this.authTicket;
  }

  public authenticationRequest(authMethodType: string, id: string, idp: string): Observable<AuthenticationTicket> {
    const params = new HttpParams().set('authMethodType', authMethodType);

    return this.httpClient.get<AuthenticationTicket>(`/siths-eid/${idp}/order`, {
      headers: this.getHeaders(id),
      params: params
    });
  }

  public getStatus(id: string, sameDevice: boolean, currentQrCodeB64: string, idp: string): Observable<PollResponse> {
    if (!this.authTicket) {
      return of(null);
    }

    return this.httpClient.get<PollResponse>(`/siths-eid/${idp}/poll`, {
      headers: this.getHeaders(id),
      params: this.getPollParams(sameDevice, currentQrCodeB64)
    });
  }

  public cancelAuthentication(id: string, idp: string): void {
    window.location.href = `/siths-eid/${idp}/cancel?id=${id}`;
  }

  private getHeaders(id: string): HttpHeaders {
    return new HttpHeaders().set('xhr', 'true').set('id', id);
  }

  private getPollParams(sameDevice: boolean, currentQrCodeB64: string): HttpParams {
    if (sameDevice || (!currentQrCodeB64 && !this.authTicket?.qrStartTokenCodeB64)) {
      return null;
    }

    let qrCodeB64 = currentQrCodeB64;
    if (!qrCodeB64 || qrCodeB64.length === 0) {
      qrCodeB64 = this.authTicket.qrStartTokenCodeB64;
    }

    return new HttpParams().set('qrCodeB64', qrCodeB64);
  }
}
